import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { useAdmin } from "@/admin/AdminContext";

const AdminLogin = () => {
    const { admin, login } = useAdmin();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (admin) navigate("/admin/dashboard", { replace: true });
    }, [admin, navigate]);

    if (admin) return null;

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin/dashboard", { replace: true });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login" className="flex min-h-screen items-center justify-center bg-mist px-5 py-10">
            <div className="w-full max-w-md rounded-3xl border border-black/10 bg-white p-8 shadow-lg">
                <div className="flex flex-col items-center">
                    <img src="/assets/logo.png" alt="Eradikbreizh" className="h-12 w-auto" />
                    <span className="mt-4 inline-flex items-center gap-2 rounded-full bg-brand/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-brand">
                        <Lock className="h-3.5 w-3.5" />
                        Espace admin
                    </span>
                </div>
                <form onSubmit={submit} className="mt-8 space-y-4">
                    <div>
                        <label htmlFor="admin-email" className="mb-1.5 block text-sm font-bold text-night">Email</label>
                        <input
                            id="admin-email"
                            data-testid="admin-login-email"
                            type="email"
                            autoComplete="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full rounded-2xl border border-black/15 px-5 py-4 text-base outline-none transition-colors focus:border-brand"
                            placeholder="contact@eradikbreizh.fr"
                        />
                    </div>
                    <div>
                        <label htmlFor="admin-password" className="mb-1.5 block text-sm font-bold text-night">Mot de passe</label>
                        <input
                            id="admin-password"
                            data-testid="admin-login-password"
                            type="password"
                            autoComplete="current-password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full rounded-2xl border border-black/15 px-5 py-4 text-base outline-none transition-colors focus:border-brand"
                            placeholder="Votre mot de passe"
                        />
                    </div>
                    {error && (
                        <p data-testid="admin-login-error" className="rounded-2xl bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">{error}</p>
                    )}
                    <button
                        data-testid="admin-login-submit"
                        type="submit"
                        disabled={loading}
                        className="flex w-full items-center justify-center gap-2 rounded-full bg-brand py-4 text-base font-bold text-white transition-[background-color,transform] duration-300 hover:bg-brand-hover active:scale-95 disabled:opacity-60"
                    >
                        <LogIn className="h-5 w-5" />
                        {loading ? "Connexion..." : "Se connecter"}
                    </button>
                </form>
                <div className="mt-6 text-center">
                    <Link to="/" className="text-sm font-semibold text-slate-500 transition-colors hover:text-brand">Retour au site</Link>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
